import {Injectable} from "@angular/core";
import {AccountingService} from "../../services/accounting.service";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {EAccountingActions, GetAccounts, GetAccountsFailure, GetAccountsSuccess} from "../../actions/accounting/accounting.actions";
import {catchError, map, switchMap, withLatestFrom} from "rxjs/operators";
import {of} from "rxjs";
import {IAccount} from "../../models/accounting/accounting.interface";

@Injectable()
export class AccountingEffects {
  Accounts$ =  createEffect(() => this._actions$.pipe(
    ofType<GetAccounts>(EAccountingActions.GetAccounts),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) =>{
      return this._accountingService.getAccounts(storeState.authentication.data.accessToken)
        .pipe(
          map(
            result =>{
              console.log('GetAccounts effect');
              const accounts:Array<IAccount> = [];
              result['report'].forEach((item) =>{
                const account:IAccount = {
                  id: item['ID'],
                  ownerPartyId: item['Owner Party ID'],
                  holderPartyId: item['Holder Party ID'],
                  type: item['Account Type'],
                  name: '',
                  status: item['Account Status'],
                  openDate: item['Creation Date'],
                  closeDate: '',
                  amount: item['Balance']
                };
                accounts.push(account);
              });
              return new GetAccountsSuccess(accounts);
            },
            catchError(error => {
              console.log(error);
              return of(new GetAccountsFailure());
            })
          )
        );
      }
    )
  ));


  constructor(
    private _accountingService: AccountingService,
    private _actions$: Actions,
    private _store$: Store<IAppState>
  ) {}

}

/*


@Injectable()
export class TasksListEffects {
  TasksList$ = this._actions$.pipe(
    ofType<GetTasksList>(ETasksActions.GetTasksList),
    withLatestFrom(this._store$),
    switchMap(([action,storeState]) => {
        return this._tasksService.getTasksList(storeState.authentication.authentication.accessToken,action.payload)
          .pipe(
            map(
              result =>{
                console.log('GetTasksList effect');
                console.log(result);
                const taskList:Array<ITask> = [];
                result['report'].forEach((item) =>{
                  const task:ITask = {
                    rid: item['ID'],

                    partyId: storeState.authenticatedUser.user.selectedPartyId,
                    partyName: '',

                    dateSubmited: item['DateSubmited'], //В формате DD.MM.YYYY
                    dateStarted: item['DateStarted'], //В формате DD.MM.YYYY
                    dateExecuted: item['DateExecuted'], //В формате DD.MM.YYYY

                    statusCode: item['Phase'],
                    errorCode: item['Status'],
                    url: item['URL'],
                    fileType: '',

                    operationCode: item['OprCode'],
                    operationName: item['OprName'],

                    description: item['Description'],
                    operationProfile: item['profile']

                  };
                  taskList.push(task);
                });

                return new GetTasksListSuccess(taskList);

              }
            ),
            catchError(error => {
              console.log(error);
              return of(new GetTasksListFailure());
            })

          );
      }
    )

  );

  constructor(
    private _tasksService: TasksService,
    private _actions$: Actions,
    private _store$: Store<IAppState>
  ) {}

}


 */
